module.exports = __webpack_public_path__ + "img/b4.94f2f525.webp";